export default __webpack_public_path__ + "static/logo-3e3507fc2732be3bfe398093aa65f830.svg";